export default {
	title: 'Algorithm Model Group',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete',
		modelConfig: 'Model Config',
		start: 'Start',
		stop: 'Stop'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete the selected {count} records?',
		deleteSuccess: 'Delete successful',
		selectDeleteWarning: 'Please select records to delete',
		operateSuccess: 'Operation successful',
		setSuccess: 'Set successful',
		configSuccess: 'Config successful',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		modelConfigNotExist: 'Model configuration does not exist'
	},
	form: {
		name: 'Model Group Name',
		code: 'Model Group Code',
		faultModelName: 'Fault Model Name',
                sys: 'Select Feature Values',
		mmcodeList: 'Select Model',
		placeholder: {
			name: 'Please enter model group name',
			code: 'Please enter model group code'
		}
	},
	table: {
		name: 'Model Group Name',
		code: 'Model Group Code',
		mmCodeDescList: 'Model Name',
		mmcodeList: 'Model Code',
		isEnable: 'Enabled'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm',
		modelConfigTitle: 'Model Configuration'
	},
	gridLayout: 'Grid Layout',
	columns: {
		deviceName: 'Device Name',
		sensorName: 'Sensor Name',
		modelGroupName: 'Model Group Name',
		modelCode: 'Model Code',
		modelName: 'Model Name',
		isEnabled: 'Enabled',
		action: 'Action'
	},
	config: {
		selectDevice: 'Select Device',
		selectSensor: 'Select Sensor',
		selectAlgorithmGroup: 'Algorithm Model Group',
		selectModel: 'Select Model',
		modelType: 'Model Type',
		modelCategory: 'Model Category',
		modelCategoryCode: 'Model Category Code',
		modelSubcategory: 'Model Subcategory',
		modelSubcategoryCode: 'Model Subcategory Code',
		modelDescription: 'Model Description',
		modelVersion: 'Model Version',
		paramConfig: 'Parameter Configuration',
		paramType: 'Parameter Type',
		paramValue: 'Parameter Value',
		paramDesc: 'Parameter Description'
	},
	waveConfig: 'Acceleration Wave Configuration',
	narrowBandWarning: 'Narrow Band Warning',
	narrowBandWarningDesc: 'Detect potential equipment faults by analyzing narrow band energy changes and issue warning (ZDYJ)',
	broadBandWarning: 'Broad Band Warning',
	broadBandWarningDesc: 'Detect potential equipment faults by analyzing broad band energy changes and issue warning (KDYJ)',
	configSuffix: ' Configuration',
	status: {
		enabled: 'Enabled',
		disabled: 'Disabled'
	}
}
